import { DayOfWeek } from './types';

export const daysOfWeek: DayOfWeek[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const defaultScheduleHours = {
  startTime: '09:00',
  endTime: '17:00',
};
